module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('van-popup', {
    attrs: {
      "position": "bottom",
      "lazy-render": false
    },
    model: {
      value: (_vm.popupShow),
      callback: function($$v) {
        _vm.popupShow = $$v
      },
      expression: "popupShow"
    }
  }, [_c('div', {
    staticClass: "page bg-fff"
  }, [_c('appStatus', {
    attrs: {
      "statusHeight": _vm.statusHeight
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-input-title",
    style: ({
      top: _vm.statusHeight + 'rem'
    })
  }, [_c('div', {
    staticClass: "alifont icon-back left-icon click",
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orgName),
      expression: "orgName"
    }],
    staticClass: "center-input fs-28",
    attrs: {
      "type": "search",
      "placeholder": "搜索小区名"
    },
    domProps: {
      "value": (_vm.orgName)
    },
    on: {
      "change": _vm.search,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orgName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right fs-28 color-333 click",
    on: {
      "click": _vm.search
    }
  }, [_vm._v("\n                搜索\n            ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasKeyword),
      expression: "!hasKeyword"
    }],
    staticClass: "pd-25"
  }, [_c('div', {
    staticClass: "mt-10 fs-36 font-bold color-333 mb-10"
  }, [_vm._v("最近选择小区")]), _vm._v(" "), _vm._l((_vm.historyList), function(item, $index) {
    return _c('div', {
      key: $index,
      staticClass: "pd-250 fs-32 color-333 bd-bot click",
      on: {
        "click": function($event) {
          return _vm.chooseOrg(item)
        }
      }
    }, [_vm._v(_vm._s(item.orgName))])
  }), _vm._v(" "), (_vm.historyList.length == 0) ? _c('div', {
    staticClass: "pd-250 fs-32 color-333 bd-bot"
  }, [_vm._v("暂无历史")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "pd-25"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasKeyword),
      expression: "!hasKeyword"
    }],
    staticClass: "mt-10 flex-between flex-center mb-10 sticky",
    style: ({
      top: (0.9 + _vm.statusHeight) + 'rem'
    })
  }, [_c('div', {
    staticClass: "fs-36 font-bold color-333"
  }, [_vm._v(_vm._s(_vm.areaName))]), _vm._v(" "), _c('div', {
    staticClass: "fs-30 color-999 click",
    on: {
      "click": function($event) {
        _vm.$refs.pickerArea.popupShow = true;
      }
    }
  }, [_vm._v("切换城市")])]), _vm._v(" "), _vm._l((_vm.data), function(item, $index) {
    return _c('div', {
      key: $index,
      staticClass: "pd-250 fs-32 color-333 bd-bot click",
      on: {
        "click": function($event) {
          return _vm.chooseOrg(item)
        }
      }
    }, [_vm._v(_vm._s(item.orgName))])
  }), _vm._v(" "), (_vm.data.length == 0) ? _c('div', {
    staticClass: "pd-250 fs-32 color-333 bd-bot"
  }, [_vm._v("暂无小区")]) : _vm._e()], 2), _vm._v(" "), _c('pickerArea', {
    ref: "pickerArea",
    on: {
      "change": _vm.areaConfirm
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-355067f8","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/locker/houseQuarterList.vue
// module id = EGZH
// module chunks = 51